import {
  Box,
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  DialogActions,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import RootComponents from "../../../components/common/RootComponents";
import { customTextColor } from "../../../utils/const";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3, CiTextAlignCenter } from "react-icons/ci";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { PiUserLight } from "react-icons/pi";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const InternalTrackerSubmit = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [openManage, setOpenManage] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleManageClickOpen = () => {
    setOpenManage(true);
  };

  const handleManageClose = () => {
    setOpenManage(false);
  };
  return (
    // <RootComponents>
      <>
      <Box className={styles.candidate_structure}>
        <Typography
          className={styles.add_internal_heading}
          style={{ color: customTextColor }}
        >
          Employer & Official References
        </Typography>
        <Box className={styles.employer_details}>
          <Typography sx={{ color: customTextColor }}>
            Employer Details
          </Typography>

          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiBuildingOfficeLight
                  sx={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Company Name"
                variant="standard"
                sx={fieldStyle}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiUserLight style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Manager’s Name"
                variant="standard"
                type="text"
                sx={fieldStyle}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Phone No "
                variant="standard"
                type="text"
                sx={fieldStyle}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="E-Mail ID "
                variant="standard"
                type="text"
                sx={fieldStyle}
              />
            </Grid>
          </Grid>
        </Box>

        <Box className={styles.employer_details}>
          <Typography sx={{ color: customTextColor }}>
            2nd Refference
          </Typography>

          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiBuildingOfficeLight
                  sx={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Company Name"
                variant="standard"
                sx={fieldStyle}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiUserLight style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Manager’s Name"
                variant="standard"
                type="text"
                sx={fieldStyle}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Phone No "
                variant="standard"
                type="text"
                sx={fieldStyle}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="E-Mail ID "
                variant="standard"
                type="text"
                sx={fieldStyle}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className={styles.add_internal_btns}>
        <button
          onClick={() => navigate("/internal-tracker-candidate")}
          style={{ backgroundColor: "#1b89de " }}
        >
          Back
        </button>
        <button
          onClick={() => navigate("/internal-tracker-submit")}
          style={{ backgroundColor: "#3856a6 " }}
        >
          Skip & Submit
        </button>
      </Box>
      </>
    // </RootComponents>
  );
};

export default InternalTrackerSubmit;
